export default __webpack_public_path__ + "static/media/notfound.4c05c98d.svg";